import React from 'react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider } from '@mdx-js/react';

import { EssentialElement, EssentialsColumn } from './ProductSuggestedLibraries';

import './ProductSuggestions.scss';

interface ProductSuggestionsProps {
  suggestions: {
    body: string;
  };
}

export default function ProductSuggestions({ suggestions }: ProductSuggestionsProps): React.ReactElement {
  return (
    <div>
      <MDXProvider
        components={{
          EssentialsColumn,
          EssentialElement,
        }}
      >
        <div className="product-suggestions">{suggestions && <MDXRenderer>{suggestions.body}</MDXRenderer>}</div>
      </MDXProvider>
    </div>
  );
}
